import React from "react";
import { Link } from "react-router-dom";
import Binding from "../../../binding";
import Context from "../../../Context";
import BsModal from "../../Misc/BsModal";
export default class JournalTupeItemDoc extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      document: {},
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let document = await this.context.api.q("/object/get", {
      id: this.props.id,
    });
    this.setState({ pending: false, document });
  };
  render() {
    const { pending, document } = this.state;
    const binding = new Binding(document);
    if (pending)
      return (
        <div className="spinner-border spinner-border-sm text-muted opacity-50"></div>
      );
    if (binding?.url) {
      return <Link to={binding.url}>{binding.label || binding.name}</Link>;
    }
    if (binding?.label || binding?.name) {
      return <div>{binding.label || binding.name}</div>;
    }
    return <div>Документ ID# {this.props.id}</div>;
  }
}
